var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrivacyPolicy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.4999 9.69998V7.09998C3.4999 5.37607 4.18472 3.72277 5.40371 2.50378C6.62269 1.28479 8.276 0.599976 9.9999 0.599976C11.7238 0.599976 13.3771 1.28479 14.5961 2.50378C15.8151 3.72277 16.4999 5.37607 16.4999 7.09998V9.69998C17.1895 9.69998 17.8508 9.9739 18.3384 10.4615C18.826 10.9491 19.0999 11.6104 19.0999 12.3V18.8C19.0999 19.4895 18.826 20.1509 18.3384 20.6385C17.8508 21.126 17.1895 21.4 16.4999 21.4H3.4999C2.81034 21.4 2.14902 21.126 1.66142 20.6385C1.17383 20.1509 0.899902 19.4895 0.899902 18.8V12.3C0.899902 11.6104 1.17383 10.9491 1.66142 10.4615C2.14902 9.9739 2.81034 9.69998 3.4999 9.69998ZM13.8999 7.09998V9.69998H6.0999V7.09998C6.0999 6.06563 6.51079 5.07365 7.24219 4.34226C7.97358 3.61087 8.96556 3.19998 9.9999 3.19998C11.0342 3.19998 12.0262 3.61087 12.7576 4.34226C13.489 5.07365 13.8999 6.06563 13.8999 7.09998Z",
    fill: "var(--klothed-textColor)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyPolicy);
export default __webpack_public_path__ + "static/media/privacyPolicy.9ce511755425ce4ea08e81d7c63acb8d.svg";
export { ForwardRef as ReactComponent };